import moment from 'moment';

const formatar = (dia, mes, ano) => {
  return new Date(`${mes}/${dia}/${ano}`);
};

function getStartOfWeek(date) {
  const startOfWeek = new Date(date);
  startOfWeek.setDate(startOfWeek.getDate() - startOfWeek.getDay());
  return startOfWeek;
}

function getEndOfWeek(date) {
  const startOfWeek = getStartOfWeek(date);
  const endOfWeek = new Date(startOfWeek);
  endOfWeek.setDate(endOfWeek.getDate() + 6);
  return endOfWeek;
}

export const handleGetOnlyDate = (change, inputName, tipoPeriodo, setDate, onChange) => {
  let dataInicial = null;
  let dataFinal = null;
  const valorInput = {
    target: { name: inputName, value: { dataInicio: dataInicial, dataFim: dataFinal } },
  };

  if (!change) {
    setDate(null);
    onChange(valorInput);
    return change;
  }

  const dataInicio = change[0]._d;
  const dataFim = change[1]._d;

  if (tipoPeriodo === 'year') {
    dataInicial = formatar('01', '01', dataInicio.getFullYear());
    dataFinal = formatar('31', '12', dataFim.getFullYear());
  } else if (tipoPeriodo === 'month') {
    dataInicial = formatar('01', dataInicio.getMonth() + 1, dataInicio.getFullYear());
    dataFinal = new Date(dataFim.getFullYear(), dataFim.getMonth() + 1, 0);
  } else if (tipoPeriodo === 'week') {
    const inicioDaSemana = getStartOfWeek(change[0]);
    const finalDaSemana = getEndOfWeek(change[1]);
    dataInicial = formatar(inicioDaSemana.getDate(), inicioDaSemana.getMonth() + 1, inicioDaSemana.getFullYear());
    dataFinal = formatar(finalDaSemana.getDate(), finalDaSemana.getMonth() + 1, finalDaSemana.getFullYear());
  } else {
    dataInicial = dataInicio;
    dataFinal = dataFim;
  }

  valorInput.target.value.dataInicio = dataInicial;
  valorInput.target.value.dataFim = dataFinal;

  onChange(valorInput);
  setDate([moment(dataInicial), moment(dataFinal)]);
  return [dataInicial, dataFinal];
};
